module.exports = __webpack_public_path__ + "static/media/error-toast-icon.42934f3e.svg";